var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86328 14C12.177 14 14.8633 11.3137 14.8633 8C14.8633 4.68629 12.177 2 8.86328 2C5.54957 2 2.86328 4.68629 2.86328 8C2.86328 11.3137 5.54957 14 8.86328 14ZM8.86328 16C13.2816 16 16.8633 12.4183 16.8633 8C16.8633 3.58172 13.2816 0 8.86328 0C4.445 0 0.863281 3.58172 0.863281 8C0.863281 12.4183 4.445 16 8.86328 16ZM8.86328 4C8.311 4 7.86328 4.44772 7.86328 5C7.86328 5.55228 8.311 6 8.86328 6C9.41557 6 9.86328 5.55228 9.86328 5C9.86328 4.44772 9.41557 4 8.86328 4ZM8.86328 12C9.41557 12 9.86328 11.5523 9.86328 11V8C9.86328 7.44772 9.41557 7 8.86328 7C8.311 7 7.86328 7.44772 7.86328 8L7.86328 11C7.86328 11.5523 8.311 12 8.86328 12Z",
    fill: "#73777C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.5263f3ededf05426d00525f802dbc98d.svg";
export { ForwardRef as ReactComponent };